import { useCallback, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  DistractionFreeMode,
  getFreeModeState,
  selectDistractionFreeMode,
  toggleDistractionFreeMode,
} from 'data/layout';
import { useToggleFreeMode } from 'hooks/use-toggle-free-mode';

interface DistractionState {
  active: boolean;
  exit: () => void;
  enter: () => void;
}

export const useDistractionFreeMode = (
  key: string | undefined = undefined,
): DistractionState => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    const distractionFreeValue = getFreeModeState(key ?? '__distractionFree');

    dispatch(toggleDistractionFreeMode(distractionFreeValue));
  }, [dispatch, key]);

  const distractionFreeActive = useSelector(selectDistractionFreeMode);

  const onToggle = useCallback(
    (value: boolean) => {
      dispatch(toggleDistractionFreeMode(value));
    },
    [dispatch],
  );

  const { active, exit, enter } = useToggleFreeMode({
    active: distractionFreeActive,
    localStorageKey: key ?? DistractionFreeMode,
    onToggle,
  });

  return {
    active,
    exit,
    enter,
  };
};
